<template>
  <v-window v-model="step" data-qa="listsoandfuturepayments-window-dodkuc">
  <v-window-item :value="1" data-qa="listsoandfuturepayments-window-item-qab0zp">
  <v-flex class="standingOrders" data-qa="listsoandfuturepayments-flex-h2e68a">
    <v-layout wrap class="ml-2 standingOrders--gradientBGposition" data-qa="listsoandfuturepayments-layout-ajw5td">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient, height: '180px' }"
       data-qa="listsoandfuturepayments-flex-9miat">
        <v-container class="standingOrders--title-padding" data-qa="listsoandfuturepayments-container-vqqom">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="listsoandfuturepayments-flex-imd715a">
            <v-row no-gutters data-qa="listsoandfuturepayments-row-tpxapj">
              <v-layout row wrap class="pb-2 pl-12" data-qa="listsoandfuturepayments-layout-czezol">
                    <div class="pt-3" data-qa="listsoandfuturepayments-div-a61tic">
                    <v-avatar :tile="false" size="35" color="white" data-qa="listsoandfuturepayments-avatar-261o2s">
                      <v-icon :color="primaryColor" data-qa="listsoandfuturepayments-icon-lt79dh">mdi-file-multiple-outline</v-icon>
                    </v-avatar>
                    </div>
                <v-flex xs9 sm9 md9 lg9 xl9 class="pt-4 pl-2" data-qa="listsoandfuturepayments-flex-mp02d8">
                  <v-row no-gutters data-qa="listsoandfuturepayments-row-e7lpo">
                    <font class="text-h5 font-weight-light white--text">
                      <font v-if="enableRecurringPaymentsOption">{{ $t("recurringAndFuturePayments.recurring")}}  & </font>
                      {{ $t("recurringAndFuturePayments.futurePayments")}}</font
                    >
                  </v-row>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex
      xs12
      sm12
      md10
      lg10
      xl10
      class="standingOrders--content-padding standingOrders--overlayCardFlex"
     data-qa="listsoandfuturepayments-flex-b1ehxj">
      <v-layout row wrap class="standingOrders--content-padding" data-qa="listsoandfuturepayments-layout-zkbyv9">
        <v-flex
          sm12
          xs12
          md12
          lg12
          xl12
          class="hidden-md-and-up bottom--pb10"
         data-qa="listsoandfuturepayments-flex-yklv">
        </v-flex>
        <v-flex xs11 sm11 md10 lg10 xl10 class="pt-0" data-qa="listsoandfuturepayments-flex-zb5zm">
          <v-card data-qa="listsoandfuturepayments-card-9ufpqq">
                <v-tabs
                  v-if="showTabs"
                  v-model="currentTab"
                  :color="primaryColor"
                  class="pl-7 pt-4 pb-2"
                 data-qa="listsoandfuturepayments-tabs-j1vjgq">
                  <v-tabs-slider
                    :color="primaryColor"
                   data-qa="listsoandfuturepayments-tabs-slider-x1wi1g"></v-tabs-slider>
                  <v-tab
                    v-for="(item, i) in standingOrderTabs"
                    :key="item"
                    :class="'text-capitalize font-weight-bold'"
                    :data-qa="`listsoandfuturepayments-tab-1j0v2-${i}`"
                  >
                    {{ item }}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="currentTab" :color="primaryColor" data-qa="listsoandfuturepayments-tabs-items-vbb5i9">
          <v-card data-qa="listsoandfuturepayments-card-dqqpy">
          <!-- 1st Tab - Recurring Payment -->
          <v-tab-item data-qa="listsoandfuturepayments-tab-item-bvuno">
          <v-card data-qa="listsoandfuturepayments-card-25v1a">
            <v-container data-qa="listsoandfuturepayments-container-3t9nep">
              <v-layout v-if="isViewSOPermitted" row justify-space-between data-qa="listsoandfuturepayments-layout-xfk1t8">
                <v-flex  xs6 sm12 md12 lg12 xl12 class="px-5 pb-6 pt-0"
                  data-qa="listsoandfuturepayments-flex-r91q4o">
                  <v-tabs
                    v-model="paymentMode"
                    :color="primaryColor"
                   data-qa="listsoandfuturepayments-tabs-0btopi">
                    <v-tab @click="resetPage('same')" data-qa="listsoandfuturepayments-tab-80j35l">
                      <font class="text-capitalize">{{
                        $t("recurringAndFuturePayments.sameBank")
                      }}</font>
                    </v-tab>
                    <v-tab @click="resetPage('other')" data-qa="listsoandfuturepayments-tab-iqo0sv">
                      <font class="text-capitalize">{{
                        $t("recurringAndFuturePayments.otherBank")
                      }}</font>
                    </v-tab>
                  </v-tabs>
                </v-flex>
                <v-flex v-if="paymentMode === 0" data-qa="listsoandfuturepayments-flex-27wq9m">
                  <v-flex v-if="paymentMode === 0" xs12 sm12 md12 lg12 xl12 data-qa="listsoandfuturepayments-flex-epn5ru">
                    <v-text-field
                      :label= "$t('recurringAndFuturePayments.searchByDescriptionOrAccount')"
                       dense
                      filled
                      :color="primaryColor"
                      class="mt-xs-auto mt-sm-auto mt-md-auto mt-n1 mt-xl-auto px-4"
                      v-model="searchFilterSO"
                      append-icon=""
                      background-color="#f0eff7 !important"
                      clearable
                      prepend-inner-icon="mdi-magnify"
                     data-qa="listsoandfuturepayments-text-field-vlowa">
                    </v-text-field>
                  </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  lg12
                  xl12
                  class="pa-12 standingOrders--centre"
                  v-if="standingOrdersList.length===0"
                 data-qa="listsoandfuturepayments-flex-vob21">
                  <v-icon class="pb-7" light size="50" data-qa="listsoandfuturepayments-icon-hf0nsd">mdi-file-multiple-outline</v-icon>
                  <v-spacer data-qa="listsoandfuturepayments-spacer-2r7e"></v-spacer>

                  <font class="subheading-1 font-weight-bold"
                    >{{ $t("recurringAndFuturePayments.noRecurringPayments") }}</font
                  >
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  lg12
                  xl12
                  v-else
                 data-qa="listsoandfuturepayments-flex-hiolqp">
                   <v-list v-if="standingOrdersList.length > 0" class="px-4 pt-0" data-qa="listsoandfuturepayments-list-h2ft8n">
                <v-list-item-content
                class= "bottom--pb5 top--pt5"
                  v-for="(payment, index) in standingOrdersList"
                  :key="index"
                  @click="onSelectStandingOrder(payment, index)"
                 :data-qa="`listsoandfuturepayments-list-item-content-rnxzvm-${index}`">
                  <v-card-text class="pa-2 standingOrders--hover" :data-qa="`listsoandfuturepayments-card-text-bpwau-${index}`">
                    <v-layout wrap :data-qa="`listsoandfuturepayments-layout-t66htf-${index}`">
                        <v-flex xs12 sm7 md7 lg7 xl7 :data-qa="`listsoandfuturepayments-flex-2547yi-${index}`">
                        <span v-if="payment.transferToAccountDetails && payment.transferToAccountDetails[0] && payment.transferToAccountDetails[0].accountId"
                           :color="primaryColor"
                           class="body-1 font-weight-regular"
                           :data-qa="`listsoandfuturepayments-span-tqx044-${index}`">{{  payment.transferToAccountDetails[0].accountId }} </span>
                      </v-flex>
                      <v-flex v-if="payment.transferToAccountDetails && payment.transferToAccountDetails.length === 1 && payment.transferToAccountDetails[0].amount && payment.transferToAccountDetails[0].amount.value" xs5 sm5 md5 lg5 xl5 class="textright hidden-xs-only" :data-qa="`listsoandfuturepayments-flex-ajod45-${index}`">
                        <span
                          class="standingOrders--amount font-weight-bold"
                          :data-qa="`listsoandfuturepayments-span-7cx1xs-${index}`">{{$formatter.currency.format(payment.transferToAccountDetails[0].amount.value, payment.transferToAccountDetails[0].amount.currency)}}
                        </span>
                      </v-flex>
                      <v-flex v-if="payment.transferToAccountDetails && payment.transferToAccountDetails.length === 1 && payment.transferToAccountDetails[0].amount && payment.transferToAccountDetails[0].amount.value" xs12 sm12 md5 lg5 xl5 class="hidden-sm-and-up" :data-qa="`listsoandfuturepayments-flex-oategzh-${index}`">
                        <span
                          class="standingOrders--amount font-weight-bold"
                          :data-qa="`listsoandfuturepayments-span-47einf-${index}`">{{$formatter.currency.format(payment.transferToAccountDetails[0].amount.value, payment.transferToAccountDetails[0].amount.currency)}}
                        </span>
                      </v-flex>
                      <v-flex v-if="payment.description" xs12 sm7 md7 lg7 xl7 :data-qa="`listsoandfuturepayments-flex-8x0xi-${index}`">
                        <span
                          class="subtitle-2 font-weight-light "
                          v-text="payment.description"
                          :data-qa="`listsoandfuturepayments-span-529cg-${index}`"></span>
                      </v-flex>
                      <v-flex v-if="payment.nextPaymentDate" xs12 sm12 md5 lg5 xl5 class="textright hidden-xs-only" :data-qa="`listsoandfuturepayments-flex-byl00a-${index}`">
                        <span
                          class="subtitle-2 font-weight-light "
                          :data-qa="`listsoandfuturepayments-span-ewqoe-${index}`">
                      {{ $t('recurringAndFuturePayments.nextPaymentDate') + ': ' + $formatter.formatDate(payment.nextPaymentDate )}}</span>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-divider :data-qa="`listsoandfuturepayments-divider-enzykn-${index}`"  v-if="!(index === standingOrdersList.length - 1)" class="standingOrders--flexBasis" />
                </v-list-item-content>
              </v-list>
                </v-flex>
                </v-flex>
                <v-flex v-if="paymentMode === 1" data-qa="listsoandfuturepayments-flex-jiy29">
                  <v-flex v-if="paymentMode === 1" xs12 sm12 md12 lg12 xl12 data-qa="listsoandfuturepayments-flex-irbmq">
                    <v-text-field
                      :label= "$t('recurringAndFuturePayments.searchByDescriptionOrAccount')"
                       dense
                      filled
                      :color="primaryColor"
                      class="mt-xs-auto mt-sm-auto mt-md-auto mt-n1 mt-xl-auto px-4"
                      v-model="searchFilterSO"
                      append-icon=""
                      background-color="#f0eff7 !important"
                      clearable
                      prepend-inner-icon="mdi-magnify"
                     data-qa="listsoandfuturepayments-text-field-1wl2cc">
                    </v-text-field>
                  </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  lg12
                  xl12
                  class="pa-12 standingOrders--centre"
                  v-if="standingOrdersList.length===0"
                 data-qa="listsoandfuturepayments-flex-m0qhir">
                  <v-icon class="pb-7" light size="50" data-qa="listsoandfuturepayments-icon-6mt1s">mdi-file-multiple-outline</v-icon>
                  <v-spacer data-qa="listsoandfuturepayments-spacer-shi7tj"></v-spacer>

                  <font class="subheading-1 font-weight-bold"
                    >{{ $t("recurringAndFuturePayments.noRecurringPayments") }}</font
                  >
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  lg12
                  xl12
                  v-else
                 data-qa="listsoandfuturepayments-flex-bex3or">
                   <v-list v-if="standingOrdersList.length > 0" class="px-4 pt-0" data-qa="listsoandfuturepayments-list-jdowo">
                <v-list-item-content
                class= "bottom--pb5 top--pt5"
                  v-for="(payment, index) in standingOrdersList"
                  :key="index"
                  @click="onSelectInterBankStandingOrder(payment, index)"
                 :data-qa="`listsoandfuturepayments-list-item-content-ktj2fu-${index}`">
                  <v-card-text class="pa-2 standingOrders--hover" :data-qa="`listsoandfuturepayments-card-text-tuq289-${index}`">
                    <v-layout wrap :data-qa="`listsoandfuturepayments-layout-blkdpk-${index}`">
                        <v-flex xs12 sm7 md7 lg7 xl7 :data-qa="`listsoandfuturepayments-flex-w4i6xo-${index}`">
                        <span v-if="payment.paymentInstruction && payment.paymentInstruction.cdtrAccount"
                           :color="primaryColor"
                           class="body-1 font-weight-regular"
                           :data-qa="`listsoandfuturepayments-span-mtdfm-${index}`">{{  payment.paymentInstruction.cdtrAccount }} </span>
                      </v-flex>
                      <v-flex v-if="payment?.paymentInstruction && payment?.paymentInstruction?.instructionAmount && payment?.paymentInstruction?.instructionAmount?.amount" xs5 sm5 md5 lg5 xl5 class="textright hidden-xs-only" :data-qa="`listsoandfuturepayments-flex-mf8237-${index}`">
                        <span
                          class="standingOrders--amount font-weight-bold"
                          :data-qa="`listsoandfuturepayments-span-o4ra5-${index}`">{{$formatter.currency.format(payment?.paymentInstruction?.instructionAmount?.amount, payment?.paymentInstruction?.instructionAmount?.currency)}}
                        </span>
                      </v-flex>
                      <v-flex v-if="payment?.paymentInstruction && payment?.paymentInstruction?.instructionAmount && payment?.paymentInstruction?.instructionAmount?.amount" xs12 sm12 md5 lg5 xl5 class="hidden-sm-and-up" :data-qa="`listsoandfuturepayments-flex-n1auy-${index}`">
                        <span
                          class="standingOrders--amount font-weight-bold"
                          :data-qa="`listsoandfuturepayments-span-fhaco2-${index}`">{{$formatter.currency.format(payment?.paymentInstruction?.instructionAmount?.amount, payment?.paymentInstruction?.instructionAmount?.currency)}}
                        </span>
                      </v-flex>
                      <v-flex v-if="payment.description" xs12 sm7 md7 lg7 xl7 :data-qa="`listsoandfuturepayments-flex-mv12ou-${index}`">
                        <span
                          class="subtitle-2 font-weight-light "
                          v-text="payment.description"
                          :data-qa="`listsoandfuturepayments-span-ytikcb-${index}`"></span>
                      </v-flex>
                      <v-flex v-if="payment.nextPaymentDate" xs12 sm5 md5 lg5 xl5 class="textright hidden-xs-only" :data-qa="`listsoandfuturepayments-flex-5w9o2d-${index}`">
                        <span
                          class="subtitle-2 font-weight-light "
                          :data-qa="`listsoandfuturepayments-span-pogyzq-${index}`">
                      {{ $t('recurringAndFuturePayments.nextPaymentDate') + ': ' + $formatter.formatDate(payment.nextPaymentDate )}}</span>
                      </v-flex>
                      <v-flex v-if="payment.standingOrderSetup && payment.standingOrderSetup.nextExecutionDate" xs12 sm5 md5 lg5 xl5 class="textright hidden-xs-only" :data-qa="`listsoandfuturepayments-flex-3bzhc-${index}`">
                        <span
                          class="subtitle-2 font-weight-light "
                          :data-qa="`listsoandfuturepayments-span-mf2lxe-${index}`">
                      {{ $t('recurringAndFuturePayments.nextPaymentDate') + ': ' + $formatter.formatDate(payment.standingOrderSetup.nextExecutionDate )}}</span>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-divider :data-qa="`listsoandfuturepayments-divider-n1sfn-${index}`"  v-if="!(index === standingOrdersList.length - 1)" class="standingOrders--flexBasis" />
                </v-list-item-content>
              </v-list>
                </v-flex>
                </v-flex>
                <!-- </v-row> -->
              </v-layout>
              <v-row
                v-if="(isSmeLogin && enableRoleBasedAccess) ? !isViewSOPermitted : false"
                no-gutters
                justify="center"
                class="ma-6 ml-0"
              >
              <div outlined class="text-center pa-6">
                <p :class="{ 'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }">
                  <font :color="errorColor" class="body-2">{{$t('errors.common.restrictedSection')}}</font>
                </p>
              </div>
            </v-row>
            </v-container>
          </v-card>
          </v-tab-item>
          <!-- 2nd Tab - Future Payment-->
          <v-tab-item data-qa="listsoandfuturepayments-tab-item-go9of">
          <v-card data-qa="listsoandfuturepayments-card-4ouve7">
            <v-container data-qa="listsoandfuturepayments-container-ahwpgc">
              <v-layout v-if="isViewSOPermitted" row justify-space-between data-qa="listsoandfuturepayments-layout-irci24">
          <v-flex  xs6 sm12 md12 lg12 xl12 class="px-4 pb-6 pt-0"
                  data-qa="listsoandfuturepayments-flex-3p6xst">
                  <v-tabs
                    v-model="paymentMode"
                    :color="primaryColor"
                    class=""
                   data-qa="listsoandfuturepayments-tabs-dcj4by">
                    <v-tab @click="resetPage('same')" data-qa="listsoandfuturepayments-tab-iwwmkg">
                      <font class="text-capitalize">{{
                        $t("recurringAndFuturePayments.sameBank")
                      }}</font>
                    </v-tab>
                    <v-tab @click="resetPage('other')" data-qa="listsoandfuturepayments-tab-epibat">
                      <font class="text-capitalize">{{
                        $t("recurringAndFuturePayments.otherBank")
                      }}</font>
                    </v-tab>
                  </v-tabs>
                </v-flex>
                  <v-flex xs12 sm12 md12 lg12 xl12 data-qa="listsoandfuturepayments-flex-6db174">
                    <v-text-field
                      :label= "$t('recurringAndFuturePayments.searchByDescriptionOrAccount')"
                       dense
                      filled
                      :color="primaryColor"
                      class="mt-xs-auto mt-sm-auto mt-md-auto mt-n1 mt-xl-auto px-4"
                      v-model="searchFilterFP"
                      append-icon=""
                      background-color="#f0eff7 !important"
                      clearable
                      prepend-inner-icon="mdi-magnify"
                     data-qa="listsoandfuturepayments-text-field-8sw99l">
                    </v-text-field>
                  </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  lg12
                  xl12
                  class="pa-12 standingOrders--centre"
                  v-if="futurePaymentsList.length===0"
                 data-qa="listsoandfuturepayments-flex-0tzsfm">
                  <v-icon class="pb-7" light size="50" data-qa="listsoandfuturepayments-icon-cjd18">mdi-file-multiple-outline</v-icon>
                  <v-spacer data-qa="listsoandfuturepayments-spacer-s09wgb"></v-spacer>

                  <font class="subheading-1 font-weight-bold"
                    >{{ $t("recurringAndFuturePayments.noFuturePayments") }}</font
                  >
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  lg12
                  xl12
                  v-else
                 data-qa="listsoandfuturepayments-flex-fu1jr8">
                   <v-list v-if="futurePaymentsList.length > 0" class="px-4 pt-0" data-qa="listsoandfuturepayments-list-9tqfu">
                <v-list-item-content
                class= "bottom--pb5 top--pt5"
                  v-for="(payment, index) in futurePaymentsList"
                  :key="index"
                  @click="onSelectStandingOrder(payment, index)"
                 :data-qa="`listsoandfuturepayments-list-item-content-kg1y3e-${index}`">
                  <v-card-text class="pa-2 standingOrders--hover" :data-qa="`listsoandfuturepayments-card-text-9vmoc-${index}`">
                    <v-layout wrap :data-qa="`listsoandfuturepayments-layout-6jaqt6-${index}`">
                  <v-flex xs12 sm7 md7 lg7 xl7 :data-qa="`listsoandfuturepayments-flex-x2z7rb-${index}`">
                         <span v-if="payment.transferToAccountDetails && payment.transferToAccountDetails.length === 1 && payment.transferToAccountDetails[0].accountId"
                           :color="primaryColor"
                           class="body-1 font-weight-regular"
                          :data-qa="`listsoandfuturepayments-span-ey7x9h-${index}`">{{  payment.transferToAccountDetails[0].accountId }}</span>
                      </v-flex>
                      <v-flex v-if="payment.paymentInstruction && payment.paymentInstruction.cdtrAccount" xs12 sm7 md7 lg7 xl7 :data-qa="`listsoandfuturepayments-flex-fo782s-${index}`">
                         <span
                           :color="primaryColor"
                           class="body-1 font-weight-regular"
                         :data-qa="`listsoandfuturepayments-span-dwmbm5-${index}`">{{  payment.paymentInstruction.cdtrAccount }}</span>
                      </v-flex>
                      <v-flex v-if="payment.transferToAccountDetails && payment.transferToAccountDetails.length === 1 && payment.transferToAccountDetails[0].amount && payment.transferToAccountDetails[0].amount.value" xs12 sm5 md5 lg5 xl5 class="textright hidden-xs-only" :data-qa="`listsoandfuturepayments-flex-ydr4pn-${index}`">
                        <span
                          class="standingOrders--amount font-weight-bold"
                          :data-qa="`listsoandfuturepayments-span-swmo49-${index}`">{{$formatter.currency.format(payment.transferToAccountDetails[0].amount.value, payment.transferToAccountDetails[0].amount.currency)}}
                        </span>
                      </v-flex>
                      <v-flex v-if="payment.transferToAccountDetails && payment.transferToAccountDetails.length === 1 && payment.transferToAccountDetails[0].amount && payment.transferToAccountDetails[0].amount.value" xs12 sm12 md5 lg5 xl5 class="hidden-sm-and-up" :data-qa="`listsoandfuturepayments-flex-7pczp2-${index}`">
                        <span
                          class="standingOrders--amount font-weight-bold"
                          :data-qa="`listsoandfuturepayments-span-2crkqc-${index}`">{{$formatter.currency.format(payment.transferToAccountDetails[0].amount.value, payment.transferToAccountDetails[0].amount.currency)}}
                        </span>
                      </v-flex>
                      <v-flex v-if="payment.paymentInstruction && payment.paymentInstruction && payment.paymentInstruction.instructionAmount.amount" xs12 sm5 md5 lg5 xl5 class="textright hidden-xs-only" :data-qa="`listsoandfuturepayments-flex-rtwa1-${index}`">
                        <span
                          class="standingOrders--amount font-weight-bold"
                          :data-qa="`listsoandfuturepayments-span-9yw76q-${index}`">{{$formatter.currency.format(payment.paymentInstruction.instructionAmount.amount, payment.paymentInstruction.instructionAmount.currency)}}
                        </span>
                      </v-flex>
                      <v-flex v-if="payment.paymentInstruction && payment.paymentInstruction && payment.paymentInstruction.instructionAmount.amount" xs12 sm12 md5 lg5 xl5 class="hidden-sm-and-up" :data-qa="`listsoandfuturepayments-flex-sozgltj-${index}`">
                        <span
                          class="standingOrders--amount font-weight-bold"
                          :data-qa="`listsoandfuturepayments-span-c6ndt5-${index}`">{{$formatter.currency.format(payment.paymentInstruction.instructionAmount.amount, payment.paymentInstruction.instructionAmount.currency)}}
                        </span>
                      </v-flex>
                      <v-flex v-if="payment.description" xs12 sm7 md7 lg7 xl7 :data-qa="`listsoandfuturepayments-flex-2zm8c9-${index}`">
                        <span
                          class="subtitle-2 font-weight-light"
                          v-text="payment.description"
                          :data-qa="`listsoandfuturepayments-span-md01o-${index}`"></span>
                      </v-flex>
                      <v-flex v-if="payment.nextPaymentDate" xs12 sm5 md5 lg5 xl5 class="textright hidden-xs-only" :data-qa="`listsoandfuturepayments-flex-2jzz1k-${index}`">
                        <span
                          class="subtitle-2 font-weight-light "
                          :data-qa="`listsoandfuturepayments-span-1182gm-${index}`">
                      {{ $t('recurringAndFuturePayments.nextPaymentDate') + ': ' + $formatter.formatDate(payment.nextPaymentDate )}}</span>
                      </v-flex>
                      <v-flex v-if="payment.standingOrderSetup && payment.standingOrderSetup.nextExecutionDate" xs12 sm5 md5 lg5 xl5 class="textright hidden-xs-only" :data-qa="`listsoandfuturepayments-flex-7diag-${index}`">
                        <span
                          class="subtitle-2 font-weight-light "
                          :data-qa="`listsoandfuturepayments-span-1pa20j-${index}`">
                      {{ $t('recurringAndFuturePayments.nextPaymentDate') + ': ' + $formatter.formatDate(payment.standingOrderSetup.nextExecutionDate )}}</span>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-divider :data-qa="`listsoandfuturepayments-divider-g3zl9-${index}`"  v-if="!(index === futurePaymentsList.length - 1)" class="standingOrders--flexBasis" />
                </v-list-item-content>
              </v-list>
                </v-flex>
              </v-layout>
              <v-row
                v-if="(isSmeLogin && enableRoleBasedAccess) ? !isViewSOPermitted : false"
                no-gutters
                justify="center"
                class="ma-6 ml-0"
              >
              <div outlined class="text-center pa-6">
                <p :class="{ 'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }">
                  <font :color="errorColor" class="body-2">{{$t('errors.common.restrictedSection')}}</font>
                </p>
              </div>
            </v-row>
            </v-container>
          </v-card>
          </v-tab-item>
          </v-card>
          </v-tabs-items>
          </v-card>
          <v-flex xs12 sm12 md12 lg12 xl12 class="pa-2" v-if="standingOrdersList || futurePaymentsList" data-qa="listsoandfuturepayments-flex-2gb3uk">
            <!-- <v-pagination
              @input="paginationChangeHandler"
              :value="pagination.page"
              :length="pageNumbers"
              :total-visible="6"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              circle
             data-qa="listsoandfuturepayments-pagination-fnnpf"></v-pagination> -->
          </v-flex>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-flex>
  </v-window-item>
  <v-window-item :value="2" data-qa="listsoandfuturepayments-window-item-mac75e" v-if="step === 2">
    <standing-order-details :sOConfig="selectedStandingOrder"></standing-order-details>
  </v-window-item>
  <v-window-item :value="3" data-qa="listsoandfuturepayments-window-item-ln62w9" v-if="step === 3">
   <amend-standing-order :amendConfig="selectedStandingOrder"></amend-standing-order>
  </v-window-item>
  </v-window>
</template>

<script>
import '@/styles/pages/standingOrders.scss'
import event from '@/util/event'
import store from '@/core/store'
import moment from 'moment'
import CommonService from '@/service/commonService.js'
import StandingOrderDetails from './StandingOrderDetails.vue'
import AmendStandingOrder from './AmendStandingOrder.vue'

export default {
  name: 'RecurringAndFuturePayments',
  components: {
    StandingOrderDetails,
    AmendStandingOrder
  },
  data () {
    return {
      currentTab: 0,
      paymentMode: 0,
      limit: 30,
      offset: 0,
      // pagination: { rowsPerPage: 20, page: 1 },
      pageNumbers: 2,
      itemLinks: {},
      requestSO: {},
      searchFilterSO: '',
      searchFilterFP: '',
      standingOrdersList: [],
      futurePaymentsList: [],
      unfilteredSO: [],
      unfilteredFP: [],
      fromDate: new Date().toISOString().substr(0, 10),
      oneYearBackDate: new Date().toISOString().substr(0, 10),
      toDate: new Date().toISOString().substr(0, 10),
      step: 1,
      selectedStandingOrder: {},
      currentDate: new Date().toISOString().substr(0, 10),
      standingOrderTabs: [
        this.$t('recurringAndFuturePayments.recurringPayments'),
        this.$t('recurringAndFuturePayments.futurePayments')
      ],
      showTabs: true,
      futurePaymentFrequency: [this.$t('recurringAndFuturePayments.daily')],
      enableRecurringPaymentsOption:
        this.$appSettings.defaultConfigurations.payments.enableRecurringPaymentsOption,
      permissions: [],
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess,
      isViewSOPermitted: false,
    }
  },
  created () {
    if (this.enableRecurringPaymentsOption) {
      this.currentTab = 0
      this.showTabs = true
    } else {
      this.currentTab = 1
      this.showTabs = false
    }
    this.permissions = store.getters['profileStore/profileData']?.permissions
    this.isViewSOPermitted = (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes('VIEW_STANDING_ORDER') : true
    
    // this.fromDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().substr(0, 10)
    this.fromDate = moment(new Date()).toISOString().substr(0, 10)
    this.toDate = new Date(new Date().setFullYear(new Date().getFullYear() + 50)).toISOString().substr(0, 10)
    this.oneYearBackDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().substr(0, 10)
    this.getPaymentsForCustomer(this.limit, this.offset)
    event.$on('goToHistory', (repeatPayment) => {
      this.step = 1
      if (repeatPayment) {
        this.getPaymentsForCustomer(this.limit, this.offset)
      }
    })
    event.$on('goToStandingOrderList', (arg) => {
      if (arg && this.paymentMode === 0) {
        this.getPaymentsForCustomer(this.limit, this.offset)
      } else {
        this.standingOrdersList = []
        this.futurePaymentsList = []
        this.pageNumbers = 0
        // if (this.currentTab === 0) {
        this.searchFilterSO = ''
        this.searchFilterFP = ''
        this.getInterBankRecurringPayments()
        // }
      }
      this.step = 1
    })
    event.$on('navigateToAmend', (args) => {
      this.selectedStandingOrder.fromAccountDescription = args.fromAccountDescription
      this.selectedStandingOrder.toAccountDescription = args.toAccountDescription
      this.step++
    })
    event.$on('amendInterBankPayment', (args) => {
      this.selectedStandingOrder.debtorAccountDescription = args.debtorAccountDescription
      this.selectedStandingOrder.creditorAccountDescription = args.creditorAccountDescription
      this.step++
    })
  },
  watch: {
    searchFilterSO () {
      this.filterByBillerOrAccount(this.searchFilterSO, 'SO')
    },
    searchFilterFP () {
      this.filterByBillerOrAccount(this.searchFilterFP, 'FP')
    }
  },
  methods: {
    resetPage (type) {
      if (type === 'same') {
        this.paymentMode = 0
      } else {
        this.paymentMode = 1
      }
      if (this.paymentMode === 0) {
        this.getPaymentsForCustomer()
      }
      if (this.paymentMode === 1) {
        this.standingOrdersList = []
        this.futurePaymentsList = []
        this.pageNumbers = 0
        // if (this.currentTab === 0) {
        this.searchFilterSO = ''
        this.searchFilterFP = ''
        this.getInterBankRecurringPayments()
        // }
      }
    },
    // paginationChangeHandler (pageNumber) {
    //   this.searchFilterSO = ''
    //   this.searchFilterFP = ''
    //   this.pagination.page = pageNumber
    //   if (this.pagination.page >= 1) {
    //     this.offset = (this.pagination.page - 1) * this.limit
    //     this.requestSO = {}
    //     this.requestSO.partyId = JSON.parse(sessionStorage.getItem('username'))
    //     this.requestSO.limit = this.limit
    //     this.requestSO.offset = this.offset
    //     this.getPaymentsForCustomer()
    //     this.setData()
    //     this.showList = true
    //   }
    // },
    // setData () {
    //   // eslint-disable-next-line no-prototype-builtins
    //   if (
    //     this.itemLinks &&
    //     Object.keys(this.itemLinks).length > 1 &&
    //     this.itemLinks.hasOwnProperty('next')
    //   ) {
    //     if (this.pageNumbers >= 2) {
    //       this.pageNumbers = this.pagination.page + 1
    //     } else {
    //       this.pageNumbers = this.pagination.page - 1
    //     }
    //   } else if (
    //     this.itemLinks &&
    //     Object.keys(this.itemLinks).length > 1 &&
    //     !this.itemLinks.hasOwnProperty('next')
    //   ) {
    //     this.pageNumbers = this.pagination.page
    //   }
    //   if (this.itemLinks && Object.keys(this.itemLinks).length === 1) {
    //     this.pageNumbers = this.pagination.page - 1
    //   }
    // },
    filterByBillerOrAccount (searchFilter, mode) {
      if (mode === 'FP') {
        if (searchFilter) {
          this.futurePaymentsList = this.unfilteredFP.filter(
            (value) => {
              if (value.description && value.description
                .toLowerCase() && value.description
                .toLowerCase()
                .includes(searchFilter.toString().toLowerCase())) {
                return true
              }
              if (value.transferToAccountDetails && value.transferToAccountDetails[0] && value.transferToAccountDetails[0].accountId) {
                return value.transferToAccountDetails[0].accountId.includes(searchFilter)
              }
              if (value.paymentInstruction && value.paymentInstruction.cdtrAccount) {
                return value.paymentInstruction.cdtrAccount.includes(searchFilter)
              }
            })
        } else {
          this.futurePaymentsList = this.unfilteredFP
        }
      }
      if (mode === 'SO') {
        if (searchFilter) {
          this.standingOrdersList = this.unfilteredSO.filter(
            (value) => {
              if (value.description && value.description
                .toLowerCase() && value.description
                .toLowerCase()
                .includes(searchFilter.toString().toLowerCase())) {
                return true
              }
              if (value.transferToAccountDetails && value.transferToAccountDetails[0] && value.transferToAccountDetails[0].accountId) {
                return value.transferToAccountDetails[0].accountId.includes(searchFilter)
              }
              if (value.paymentInstruction && value.paymentInstruction.cdtrAccount) {
                return value.paymentInstruction.cdtrAccount.includes(searchFilter)
              }
            })
        } else {
          this.standingOrdersList = this.unfilteredSO
        }
      }
    },
    onSelectStandingOrder (standingOrder, index) {
      if (standingOrder.status === 'ACTIVE' || standingOrder.standingOrderStatus === 'ACTIVE') {
        if (standingOrder.transferToAccountDetails) {
          standingOrder.type = 'same'
        } else {
          standingOrder.type = 'other'
        }
        this.step++
        this.selectedStandingOrder = standingOrder
        event.$emit('reviewDetails', standingOrder)
      }
    },
    onSelectInterBankStandingOrder (standingOrder, index) {
      if (standingOrder.standingOrderStatus === 'ACTIVE') {
        standingOrder.type = 'other'
        this.step++
        this.selectedStandingOrder = standingOrder
        event.$emit('reviewDetails', standingOrder)
      }
    },
    getDate (val) {
      return new Date(Date.now() - parseInt(val) * 24 * 60 * 60 * 1000)
        .toISOString()
        .substr(0, 10)
    },
    getPaymentsForCustomer () {
      this.searchFilterSO = ''
      this.searchFilterFP = ''
      this.requestSO = {}
      this.requestSO.limit = this.limit
      this.requestSO.offset = this.offset
      this.requestSO.partyId = JSON.parse(sessionStorage.getItem('username'))
      this.listStandingOrders()
    },
    checkIsAfter (date1, date2) {
      return moment(date1).isAfter(date2)
    },
    async listStandingOrders () {
      this.pageNumbers = 2
      this.unfilteredSO = []
      this.standingOrdersList = []
      this.unfilteredFP = []
      this.futurePaymentsList = []
      this.itemLinks = {}
      const response = await CommonService.listStandingOrders(this.requestSO)
      if (response && response.items) {
        response.items.forEach((item, index) => {
          if (item.startDate && item.frequency && item.status && item.status.toUpperCase() === 'ACTIVE') {
            if (
              this.futurePaymentFrequency.includes(item.frequency.toUpperCase())
            ) {
              const startDate = moment(item.startDate, 'YYYY-MM-DD')
              if (item.endDate && this.checkIsAfter(item.endDate, this.currentDate)) {
                const endDate = moment(item.endDate, 'YYYY-MM-DD')
                const expectedEndDate = moment(startDate).add(1, 'days')
                if (endDate.isSame(expectedEndDate)) {
                  this.futurePaymentsList.push(item)
                } else {
                  this.standingOrdersList.push(item)
                }
              } else if (item.numberOfPayments && item.nextPaymentDate) {
                const startDate = moment(item.startDate, 'YYYY-MM-DD')
                const nextPaymentDate = moment(item.nextPaymentDate, 'YYYY-MM-DD')
                // const diff = nextPaymentDate.diff(startDate, 'days')
                if ((nextPaymentDate >= startDate) && item.numberOfPayments === 1 && item.frequency === 'DAILY') {
                  this.futurePaymentsList.push(item)
                } else {
                  this.standingOrdersList.push(item)
                }
              }
            } else {
              this.standingOrdersList.push(item)
            }
          }
        })
      }
      this.itemLinks = response?.links || {}
      this.unfilteredSO = this.standingOrdersList.sort((a, b) => a.nextPaymentDate.localeCompare(b.nextPaymentDate))
      this.unfilteredFP = this.futurePaymentsList.sort((a, b) => a.nextPaymentDate.localeCompare(b.nextPaymentDate))
      // this.setData()
    },
    async getInterBankRecurringPayments () {
      const payload = {}
      this.unfilteredSO = []
      payload.customerId = JSON.parse(sessionStorage.getItem('username'))
      payload.fromDate = this.oneYearBackDate
      payload.toDate = this.toDate
      const response = await CommonService.getInterBankStandingOrders(payload)
      if (response && response.items) {
        response.items.forEach((item, index) => {
          if (item?.standingOrderId && item?.standingOrderStatus?.toUpperCase() === 'ACTIVE') {
            if (item.standingOrderSetup.numberOfPayments === 1 && item.standingOrderSetup.frequency === 'DAILY') {
              this.futurePaymentsList.push(item)
            } else {
              this.standingOrdersList.push(item)
            }
            this.unfilteredSO = this.standingOrdersList.sort((a, b) => a.standingOrderSetup.nextExecutionDate.localeCompare(b.standingOrderSetup.nextExecutionDate))
            this.unfilteredFP = this.futurePaymentsList.sort((a, b) => a.standingOrderSetup.nextExecutionDate.localeCompare(b.standingOrderSetup.nextExecutionDate))
          }
        })
      }
    }
  }
}
</script>
